import { render, staticRenderFns } from "./enterpriseAccount.vue?vue&type=template&id=470c806c&scoped=true&"
import script from "./enterpriseAccount.vue?vue&type=script&lang=js&"
export * from "./enterpriseAccount.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseAccount.vue?vue&type=style&index=0&id=470c806c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c806c",
  null
  
)

export default component.exports